import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { EntranceDateSubForm } from '../subforms/EntranceDate';
import { SalaryRequestSubForm, Schema as SalaryRequestSchema } from '../subforms/SalaryRequest';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const WarburgStandardSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(NameAndContactSchema(settings))
        .concat(SalaryRequestSchema)
        .concat(DocumentsSchema(settings))
);

export const WarburgStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={SalutationSubForm} colors={colors} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />
            <Field component={SalaryRequestSubForm} colors={colors} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}